const STYLE_FOLDERS: Record<string, string> = {
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fab': 'brands',
  'fa-brands': 'brands'
}
const UTILITY_CLASSES = new Set(['fa-spin'])

/**
 * Points a Font Awesome class list (e.g. `fab fa-discord`) at its generated SVG.
 * Icons written in templates get this from `icons.generated.css`; icons whose name
 * comes from the API are unknown at build time and need it inline.
 */
export const faIconStyle = (classes: string): Record<string, string> => {
  const tokens = classes.trim().split(/\s+/)
  const folder = tokens.map(token => STYLE_FOLDERS[token]).find(Boolean) ?? 'solid'
  const name = tokens.find(token => token.startsWith('fa-') && !STYLE_FOLDERS[token] && !UTILITY_CLASSES.has(token))
  if (!name) return {}
  return { '--fa-icon': `url(/icons/${folder}/${name.slice(3)}.svg)` }
}
